<template>
  <div
    class="row q-gutter-x-sm justify-center q-py-sm bg-white full-width bdr-t-grey-4"
  >
    <SAIBtn
      :no-caps="true"
      class="all-pointer-events"
      size="16px"
      :disable="disable"
      :loading="loadingAccepting"
      padding="11px xl"
      label="I’m ready to accept"
      @click="$emit('accept')"
    />
  </div>
</template>

<script>
import { SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'SummaryActions',
  props: {
    disable: Boolean,
    loadingAccepting: Boolean
  },
  components: {
    SAIBtn
  }
};
</script>
